import React from "react";
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import {
    eventBus,
    toast,
    ToastTypes,
} from "../../../../components/ajonjolib/toasts/toast/toast";
import axiosInstance from "../../../../AxiosInstance";


export default function ResetINAButton({ pduiId }) {
    const { t } = useTranslation();
    const [loading, setLoading] = React.useState(false);

    const resetINA = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.post(
                `/pdui/${pduiId}/reset_ina/`
            );
            if (response.status === 200) {
                toast("Se envió la orden de reinicio de INA", ToastTypes.SUCCESS);
            }
        } catch (error) {
            console.error(t('resetIna.error'), error);
            if (error.response) {
                toast(
                    `${t('resetIna.error')}: ${error.response.data.message}`,
                    ToastTypes.ERROR
                );
            } else {
                toast(t('resetIna.error'), ToastTypes.ERROR);
            }
        } finally {
            setLoading(false);
        }
    }
    return (
        <div
            onClick={() => {
                if (!loading) resetINA();
            }}
            className={"d-flex justify-content-center align-items-center"}
            style={{
                color: loading ? "#CCC" : "red",
                backgroundColor: loading ? "#CCC" : "#FFF",
                borderRadius: "6px",
                padding: "8px 16px",
                cursor: loading ? "not-allowed" : "pointer",
                userSelect: "none",
                border: `${loading ? "#CCC" : "red"} 1px solid`,
            }}
        >
            <FontAwesomeIcon
                icon={faRefresh}
                size={"xl"}
                color={loading ? "#CCC" : "red"}
                className={"me-2"}
            />
            <div>Reset INA</div>
        </div>
    );
}